import { SkeletonText, Text } from '@customerio/pluma-components/react';
import type { UsageSummary } from '../utils/usage-summary';
import { UsageChips } from './usage-chips';

/**
 * Where one row is used, as much of it as a column can hold.
 *
 * The counts arrive from their own read, after the rows, so the cell is a
 * skeleton until they land rather than a dash that turns into numbers.
 */

type UsageCellProps = {
  summary: UsageSummary;
  isLoading: boolean;
};

export function UsageCell({ summary, isLoading }: UsageCellProps) {
  if (isLoading) {
    return <SkeletonText text="product-p" lines={['60px']} />;
  }

  if (summary.chips.length === 0) {
    return <Text color="subtle">-</Text>;
  }

  return <UsageChips chips={summary.chips} tooltip={summary.tooltip} />;
}
